export default {
    winzApiUrl: 'https://ep-winz-api-prod-bvgcbrcdejgheca7.a03.azurefd.net',
    clientId: '99618d6b-e912-4a52-83c8-76cfc511ad67',
    authority:'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 2, // Default to Warning level
};